import * as React from 'react';
import { Formik, Form } from 'formik';

import TextField from '../textField';

import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalTitle
} from '../modal';
import { duplicateOptionPackValidationSchema } from '../validation/validationSchema';

interface IDuplicateOptionPackProps {
    duplicatedOptionPack: any;
    onClose: () => void;
    handleSubmit: (values, actions) => void;
}

const DuplicateOptionPackModal: React.FC<IDuplicateOptionPackProps> = (
    props
) => {
    const { duplicatedOptionPack, onClose, handleSubmit } = props;
    return (
        <Modal className="modal__heightauto" isOpen={true}>
            <ModalHeader onClose={onClose}>
                <ModalTitle>Duplicate option pack</ModalTitle>
            </ModalHeader>
            <Formik
                initialValues={{
                    label: `${duplicatedOptionPack.label} copy`
                }}
                validationSchema={duplicateOptionPackValidationSchema}
                onSubmit={(values, actions) => {
                    handleSubmit(values, actions);
                }}
                render={({
                    values,
                    touched,
                    handleChange,
                    handleBlur,
                    errors,
                    dirty,
                    isSubmitting
                }) => (
                    <Form>
                        <ModalBody>
                            <TextField
                                type="text"
                                name="label"
                                value={values.label}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder=""
                                label="Option Group Label"
                                errorMessage={errors.label}
                                touchedValue={touched.label}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <button
                                className="btn btn--sm btn--transparent m-r-10"
                                disabled={isSubmitting}
                                onClick={() => onClose()}
                            >
                                Cancel
                            </button>
                            <button
                                disabled={isSubmitting}
                                className="btn btn--sm btn--green"
                                type="submit"
                            >
                                {isSubmitting
                                    ? 'Duplicating...'
                                    : 'Duplicate and edit'}
                            </button>
                        </ModalFooter>
                    </Form>
                )}
            />
        </Modal>
    );
};

export default DuplicateOptionPackModal;
